import React from 'react';
import { Modal, Button } from '@salesforce/design-system-react';
import {CONSTANT_ACCESS_REQUEST} from "../../../../constants/accessRequest";

type AccessRequestConfirmationModalProps = {
    isOpen: boolean;
    toggleModal: (isOpen: boolean) => void;
    onConfirm: () => void;
    actionType: string;
};

const ReasonConfirmationModal: React.FC<AccessRequestConfirmationModalProps> = ({
   isOpen,
   toggleModal,
   onConfirm,
   actionType,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => toggleModal(false)}
            heading={`Confirm ${actionType}`}
            prompt="error"
            footer={[
                <Button label={CONSTANT_ACCESS_REQUEST.CONFIRM} variant="brand" onClick={onConfirm} />,
                <Button label={CONSTANT_ACCESS_REQUEST.CANCEL} onClick={() => toggleModal(false)}/>,
            ]}
        >
            <p className="slds-p-around_medium">Are you sure you want to {actionType.toLowerCase()} this reason?</p>
        </Modal>
    );
};

export default ReasonConfirmationModal;
